import { DataSource, Layout, Panel, Switch, Table } from "@mcleod/components";

export abstract class AutogenLayoutCollectionsGroupByTable extends Layout {
    panelGroupByHeader: Panel;
    sourceCollections: DataSource;
    switchGroupBy: Switch;
    tableGroupBy: Table;
}
